import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavService } from '../../services/nav.service';
import { SidebarRightService } from '../../services/sidebar-right.service';
import { SwitcherService } from '../../services/switcher.service';

@Component({
    selector: 'app-header-one',
    templateUrl: './header-one.component.html',
    styleUrls: ['./header-one.component.scss'],
    standalone: false
})
export class HeaderOneComponent implements OnInit {

  layoutSubscription: Subscription;
  public isCollapsed = true;

  constructor(
    private sidebarRightservice: SidebarRightService,
    public navServices: NavService,
    public SwitcherService: SwitcherService,
  ) {
    this.layoutSubscription = sidebarRightservice.changeEmitted.subscribe(
      direction => {
        const dir = direction.direction;

      }
    )
  }

  ngOnInit(): void {
    let navbarForm:any = document.querySelector('.navbar-form')
    navbarForm.addEventListener('click',(event:any)=>{
      event.preventDefault();
      return;
    }, {passive: false})
  }

  toggleSwitcher() {
    this.SwitcherService.emitChange(true);
  }

  toggleSidebarNotification() {
    this.sidebarRightservice.emitSidebarNotifyChange(true);
  }
  toggleSidebarOpen(){
    if ((this.navServices.collapseSidebar = true)) {
      let mainBody:any = document.querySelector('.main-body')
      mainBody.classList.add('sidenav-toggled');
    }
  }
  toggleSidebarClose(){
    if ((this.navServices.collapseSidebar = true)) {
      let removeMainBody:any = document.querySelector('.main-body')
      removeMainBody.classList.remove('sidenav-toggled');
    }
  }

  search(){
    let navabarForm:any = document.querySelector('.navbar-form ')
    navabarForm.classList.toggle('d-none')
  }
  close(){
    let navbarD:any = document.querySelector('.navbar-form ')
    navbarD.classList.add('d-none')
  }

  ngAfterViewInit(){
  }

  SearchActive = "Notactive" 
  searchClass(item:any){
    // this.SearchActive=="nonactive"? "active":"nonactive"
    console.log(item);
    if (item=="active") {
      this.SearchActive = "active"
    }
    if (item=="Notactive") {
      this.SearchActive = "Notactive"
    }
  }


}
